/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:26
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-01-17 10:55:12
 * @Description: file content
 * @FilePath: \edc-web\src\utils\global.js
 */
class Global {
	/**
  * @description:补零
  * @param {*} num 要的数
  * @param {*} n 保留几位
  * @return {*}
  */
	addZero(num, n) {
		return (Array(n).join(0) + num).slice(-n)
	}
	/**
  * @description:数组项某一字段存在相同值
  * @param {*} arr 数组
  * @param {*} index 需要检查字段
  */
	arrayRepeat(arr, index) {
		if (!this.isArrayFn(arr)) return
		var hash = {}
		for (var i in arr) {
			if (index) {
				if (hash[arr[i][index]]) {
					return true
				}
				hash[arr[i][index]] = true
			} else {
				if (hash[arr[i]]) {
					return true
				}
				hash[arr[i]] = true
			}
		}
		return false
	}
	/**
  * @description: 纯数组排序
  * @param {*} array 数组
  * @param {*} type 1,max ,2,min
  * @return {*}
  */
	arraySort(array, type) {
		type = type || 1
		if (this.isArrayFn(array)) {
			const arr = this.deepClone(array)
			arr.sort(function(x, y) {
				return type === 1 ? y - x : x - y
			})
			return arr
		} else {
			return []
		}
	}
	/**
  * @description:回到顶部
  * @param {*} dom
  * @param {*} step
  * @return {*}
  */
	backtop(dom, step = 5, childrenClass) {
		if (!dom) return
		let scrollDom = dom
		if (childrenClass)scrollDom = this.getParentdElement(dom, childrenClass)
		const timer = setInterval(() => {
			const scrollTop = scrollDom.scrollTop || scrollDom.scrollTop
			const ispeed = Math.floor(-scrollTop / step)
			scrollDom.scrollTop = scrollTop + ispeed
			scrollTop === 0 && clearInterval(timer)
		}, 30)
	}
	/**
  * @description:清除定时器
  * @param {*} time 定时器
  * @param {*} type 1 timeout  2 timeIntever
  * @return {*}
  */
	clearTime(time, type) {
		type === 1 ? clearTimeout(time) : clearInterval(time)
		time = null
	}
	/**
  * @description:对象反序
  * @param {*} object 对象
  * @return {*}
  */
	changeObjectKey(object) {
		const newObject = {}
		if (this.isObject(object)) {
			for (const key in object) {
				newObject[object[key]] = key
			}
		}
		return newObject
	}
	/**
  * @description:深度拷贝
  * @param {*} object 对象
  * @return {*}
  */
	deepClone(object) {
		var cloneObject = Array.isArray(object) ? [] : {}
		if (object && typeof object === 'object' && object != null) {
			for (var key in object) { //  循环对象类型的obj
				if (this.judgeKey(object, key)) {
					if (object[key] && typeof object[key] === 'object') {
						cloneObject[key] = this.deepClone(object[key])
					} else { //  否则就是浅复制
						cloneObject[key] = object[key]
					}
				}
			}
		}
		return cloneObject
	}
	/**
  * @description:通过a标签下载
  * @param {*} res
  * @param {*} fileName
  * @return {*}
  */
	downloadFile(res, fileName) {
		if (!res) {
			return
		}
		if (window.navigator.msSaveBlob) { // IE以及IE内核的浏览器
			try {
				window.navigator.msSaveBlob(res, fileName)
				// window.navigator.msSaveOrOpenBlob(res, fileName);  //此方法类似上面的方法，区别可自行百度
			} catch (e) {
				console.log(e)
			}
		} else {
			const url = window.URL.createObjectURL(new Blob([res]))
			const link = document.createElement('a')
			link.style.display = 'none'
			link.href = url
			link.setAttribute('download', fileName)// 文件名
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link) // 下载完成移除元素
			window.URL.revokeObjectURL(url) // 释放掉blob对象
		}
	}
	/**
  * @description:文档下载（通过文档请求，直接下载文档）
  * @param {*} url 请求路径
  * @param {*} fileName 下载名称
  * @param {*} size 文件大小
  * @return {*}
  */
	loadDown(url, fileName, size) {
		var _this = this
		var xhr = new XMLHttpRequest()
		xhr.open('GET', url, true) // 也可以使用POST方式，根据接口
		xhr.responseType = 'blob'
		xhr.onprogress = function(event) {
			// 用于监听下载进度，需要知道文件大小
			if (event.loaded === size) {
				_this.downloadLoading = false
			}
		}
		xhr.onload = function() {
			if (this.status === 200) {
				var content = this.response
				var aTag = document.createElement('a')
				var blob = new Blob([content])
				aTag.download = fileName
				aTag.href = URL.createObjectURL(blob)
				aTag.click()
				URL.revokeObjectURL(blob)
			}
		}
		xhr.send()
	}
	/**
  * @description:函数防抖
  * @param {*} func 目标函数
  * @param {*} wait 延迟执行毫秒数
  * @param {*} immediate true - 立即执行， false - 延迟执行
  * @return {*}
  */
	debounce(func, wait, immediate) {
		let timer
		return function() {
			const context = this
			const args = arguments
			if (timer) clearTimeout(timer)
			if (immediate) {
				const callNow = !timer
				timer = setTimeout(() => {
					timer = null
				}, wait)
				if (callNow) func.apply(context, args)
			} else {
				timer = setTimeout(() => {
					func.apply
				}, wait)
			}
		}
	}
	/**
  * @description:字符串操作符
  * @param {*} value
  * @return {*}
  */
	eval(value) {
		var Fn = Function
		return new Fn('return ' + value)()
	}
	/**
  * @description:检测flash
  * @param {*}
  * @return {*}
  */
	flashChecker() {
		let hasFlash = false // 是否安装了flash
		if (document.all) {
			const swf = new ActiveXObject('ShockwaveFlash.ShockwaveFlash')
			if (swf) {
				hasFlash = true
			}
		} else {
			if (navigator.plugins && navigator.plugins.length > 0) {
				const swf = navigator.plugins['Shockwave Flash']
				if (swf) {
					hasFlash = true
				}
			}
		}
		return hasFlash
	}
	/**
  * @description:获取图片尺寸
  * @param {*} url 图片地址
  * @param {*} callback 回调函数
  * @return {*}
  */
	getImageSize(url, callback) {
		var img = new Image()
		img.src = url
		// 如果图片被缓存，则直接返回缓存数据
		if (img.complete) {
			callback(img.width, img.height, true)
		} else {
			img.onload = function() {
				callback(img.width, img.height, true)
			}
			img.onerror = function() {
				callback(img.width, img.height, false)
			}
		}
	}
	/**
  * @description:获取dom尺寸
  * @param {*} dom 元素
  * @return {*}
  */
	getDomSize(dom) {
		if (dom.getBoundingClientRect()) {
			return {
				width: dom.getBoundingClientRect().width,
				height: dom.getBoundingClientRect().height
			}
		} else {
			return {
				width: dom.offsetWidth,
				height: dom.offsetHeight
			}
		}
	}
	getParentdElement(parentNode, childName) {
		// 如果父节点parentNode含有指定类名childName，这个节点就是目标节点
		// console.log(parentNode, childName)
		// console.log(parentNode.className.search(childName))
		if (parentNode.className.search(childName) !== -1) {
			return parentNode
		} else {
			// 父节点不含有指定类名childName，递归查找它的子节点。
			var nodes = parentNode.childNodes
			// 将子节点的list转换成标准数组并且过滤掉Text元素
			nodes = this.transformList(nodes).filter(function(item) {
				if (item.nodeType !== 3) {
					return item
				}
			})
			for (let i = 0; i < nodes.length; i++) {
				const childrenNode =	this.getParentdElement(nodes[i], childName)
				if (childrenNode) {
					return childrenNode
				}
			}
		}
	}
	/**
  * @description:判断浏览器
  * @param {*}
  * @return {*}
  */
	getOs() {
		if (navigator.userAgent.indexOf('MSIE 8.0') > 0) {
			return 'MSIE8'
		} else if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
			return 'MSIE6'
		} else if (navigator.userAgent.indexOf('MSIE 7.0') > 0) {
			return 'MSIE7'
		} else if (isFirefox === navigator.userAgent.indexOf('Firefox') > 0) {
			return 'Firefox'
		}
		if (navigator.userAgent.indexOf('Chrome') > 0) {
			return 'Chrome'
		} else {
			return 'Other'
		}
	}
	/**
  * @description:得到数组最值
  * @param {*} array 数组
  * @param {*} index 需要获取得数组
  * @param {*} type 1,max ,2,min
  * @return {*}
  */
	getMaxIndexNum(array, index, type) {
		type = type || 1
		if (this.isArrayFn(array)) {
			const list = array.map(item => { return item[index] })
			const num = type === 1 ? this.getMaxNum(list) : this.getMinNum(list)
			return num
		} else {
			return 0
		}
	}
	/**
  * @description:得到数组最大值
  * @param {*} array
  * @return {*}
  */
	getMaxNum(array) {
		if (this.isArrayFn(array)) {
			const max = Math.max.apply(null, array)
			return max
		} else {
			return 0
		}
	}
	/**
  * @description:得到数组最小值
  * @param {*} array
  * @return {*}
  */
	getMinNum(array) {
		if (this.isArrayFn(array)) {
			const min = Math.min.apply(null, array)
			return min
		} else {
			return 0
		}
	}
	/**
  * @description:填充指定值的数组
  * @param {*} length 长度
  * @param {*} num 指定数
  * @return {*}
  */
	getArray(length, num) {
		const list = []
		for (let i = 0; i < length; i++) {
			list.push(num)
		}
		return list
	}
	/**
  * @description:获取指定index的数组
  * @param {*} list
  * @param {*} index
  * @return {*}
  */
	getIndexList(list, index) {
		if (!this.isArrayFn(list)) return []
		const array = list.map(item => {
			return item[index]
		})
		return array
	}
	/**
  * @description:得到indexArray
  * @param {*} list
  * @param {*} key
  * @return {*}
  */
	getIndexArray(list, key = 'seq') {
		if (this.isArrayFn(list)) {
			const infoList = this.deepClone(list)
			return infoList.map((item, index) => {
				item[key] = index
				return item
			})
		} else {
			return []
		}
	}
	/**
  * @description:得到文件大小
  * @param {*} limit
  * @return {*}
  */
	getFileSize(limit) {
		let size = ''
		if (limit < 0.1 * 1024) {
			size = limit.toFixed(2) + 'B'
		} else if (limit < 0.1 * 1024 * 1024) {
			size = (limit / 1024).toFixed(2) + 'KB'
		} else if (limit < 0.1 * 1024 * 1024 * 1024) {
			size = (limit / (1024 * 1024)).toFixed(2) + 'MB'
		} else { // 其他转化成GB
			size = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
		}
		var sizeStr = size + '' // 转成字符串
		var index = sizeStr.indexOf('.') // 获取小数点处的索引
		var dou = sizeStr.substr(index + 1, 2) // 获取小数点后两位的值
		if (dou === '00') { // 判断后两位是否为00，如果是则删除00
			return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
		}
		return size
	}
	/**
  * @description: 返回rgb
  * @param {*} R
  * @param {*} G
  * @param {*} B
  * @return {*}
  */
	getRGB(R, G, B) {
		return `RGB(${R},${G},${B})`
	}
	/**
  * @description:随机颜色
  * @param {*}
  * @return {*}
  */
	getRandomColor() {
		return '#' + (Math.random() * 0xffffff << 0).toString(16)
	}
	/**
  * @description:获取视口尺寸
  * @param {*}
  * @return {*}
  */
	getViewportOffset() {
		if (window.innerWidth) {
			return {
				w: window.innerWidth,
				h: window.innerHeight
			}
		} else {
			// ie8及其以下
			if (document.compatMode === 'BackCompat') {
				// 怪异模式
				return {
					w: document.body.clientWidth,
					h: document.body.clientHeight
				}
			} else {
				// 标准模式
				return {
					w: document.documentElement.clientWidth,
					h: document.documentElement.clientHeight
				}
			}
		}
	}
	/**
  * @description:是否是操作符
  * @param {*} value 任意类型值
  * @return {*}
  */
	isOper(value) {
		return ['+', '-', '*', '/'].indexOf(value) >= 0
	}
	/**
  * @description:判断是否是JSON
  * @param {*} value 任意类型值
  * @return {*}
  */
	isJSON(value) {
		if (this.isString(value)) {
			try {
				var obj = JSON.parse(value)
				if (typeof obj === 'object' && obj) {
					return true
				} else {
					return false
				}
			} catch (error) {
				return false
			}
		}
	}
	/**
  * @description:判断是否是数组
  * @param {*} value 任意类型值
  * @return {*}
  */
	isArrayFn(value) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(value)
		} else {
			return Object.prototype.toString.call(value) === '[object Array]'
		}
	}
	/**
  * @description:判断是否是字符串
  * @param {*} value 任意类型值
  * @return {*}
  */
	isString(value) {
		return (typeof value === 'string') && value.constructor === String
	}
	/**
  * @description:判断是否是code
  * @param {*} value 任意类型值
  * @return {*}
  */
	isSingleCode(value) {
		return /[a-z0-9]{16}$/.test(value)
	}
	/**
  * @description:判断是否是undefined
  * @param {*} value 任意类型值
  * @return {*}
  */
	isUndefind(value) {
		return typeof (value) === 'undefined'
	}
	/**
  * @description:判断是否是数字
  * @param {*} value 任意类型值
  * @return {*}
  */
	isNumebr(value) {
		return typeof value === 'number' && !isNaN(value)
	}
	/**
  * @description:判断是否是对象
  * @param {*} value 任意类型值
  * @return {*}
  */
	isObject(value) {
		return (typeof value === 'object') && value.constructor === Object
	}
	/**
  * @description:判断是否为空
  * @param {*} value 任意类型值
  * @return {*}
  */
	isEmpty(value) {
		if (value == null) return true
		if (value.length > 0) return false
		if (value.length === 0) return true
		if (!Object.keys(value).length) return true
		for (const key in value) {
			if (hasOwnProperty.call(value, key)) return false
		}
		return true
	}
	/**
  * @description:判断是否为null
  * @param {*} value 任意类型值
  * @return {*}
  */
	isNull(value) {
		return value === null || typeof (value) === 'undefined'
	}
	/**
		 * @method     判断是否为数字
		 * @param value 任意类型值
		 */
	isNum(value) {
		return /^(-)?\d+(\.\d+)?$/.test(value)
	}
	/**
  * @description:判断是否为时间
  * @param {*} value 任意类型值
  * @return {*}
  */
	isTime(value) {
		return new RegExp(/^(?:\d{2}):\d{2}$/).test(value)
	}
	/**
  * @description:判断是否为日期
  * @param {*} value 任意类型值
  * @return {*}
  */
	isDate(value) {
		return new RegExp(/\b(\d{4})\/(\d{2})\/(\d{2})\b/).test(value)
	}
	/**
  * @description: 判断是日期时间
  * @param {*} value 任意类型值
  * @return {*}
  */
	isDatetime(value) {
		return new RegExp(
			/\b(\d{4})-(\d{2})-(\d{2})\b (?:\d{2}):\d{2}:\d{2}$/
		).test(value)
	}
	/**
  * @description: 判断是item
  * @param {*} value 任意类型值
  * @return {*}
  */
	isSingleitemCode(value) {
		return /[a-z0-9]{16}$/.test(value)
	}
	/**
  * @description: 判断是图片
  * @param {*} fileName 文件名
  * @return {*}
  */
	isImage(fileName) {
		if (typeof fileName !== 'string') return
		const name = fileName.toLowerCase()
		return name.endsWith('.png') || name.endsWith('.jpeg') || name.endsWith('.jpg') || name.endsWith('.png') || name.endsWith('.bmp')
	}
	/**
  * @description: 判断对象是否存在key
  * @param {*} obj
  * @param {*} key
  * @return {*}
  */
	judgeKey(obj, key) {
		return Object.prototype.hasOwnProperty.call(obj, key)
	}
	/**
  * @description: 监听远程图片
  * @param {*} url 图片地址
  * @param {*} callback 回调函数
  * @return {*}
  */
	listenImg(url, callback) {
		var img = new Image()
		img.src = url
		img.onload = function() {
			callback(true)
		}
		img.onerror = function() {
			callback(false)
		}
	}
	/**
  * @description: 页码切换获取指定数组
  * @param {*} pageSize 每页数量
  * @param {*} currentPage 当前页
  * @param {*} array 数组
  * @return {*}
  */
	pageArray(pageSize, currentPage, array) {
		if (!this.isArrayFn(array)) return []
		const list = this.deepClone(array)
		const current = list.splice(
			(currentPage - 1) * pageSize,
			pageSize
		)
		return current
	}
	/**
  * @description: 得到范围之内随机数
  * @param {*} m 初始值
  * @param {*} n 结束值
  * @return {*}
  */
	randomRange(m, n) {
		var num = Math.floor(Math.random() * (m - n) + n)
		return num
	}
	/**
  * @description: 去除前后空格
  * @param {*} str
  * @param {*} type 1,全部 2 左右 3左 4右
  * @return {*}
  */
	replaceTrim(str, type) {
		if (this.isString(str)) {
			switch (type) {
			case 1:
				return str.replace(/\s+/g, '')
			case 2:
				return str.replace(/^\s+|\s+$/g, '')
			case 3:
				return str.replace(/^\s/, '')
			case 4:
				return str.replace(/(\s$)/g, '')
			default:
				return str.replace(/^\s+|\s+$/g, '')
			}
		} else {
			return str
		}
	}
	/**
  * @description: 切割指定字符串
  * @param {*} str 指定字符串
  * @param {*} flag 分隔符
  * @return {*}
  */
	splitStr(str, flag) {
		if (this.isString(str)) {
			const stringArray = str.split(flag)
			return stringArray
		} else {
			return ['', '']
		}
	}
	/**
  * @description:转换
  * @param {*} list
  * @return {*}
  */
	transformList(list) {
		const arr = []
		for (var i = 0; i < list.length; i++) {
			arr.push(list[i])
		}
		return arr
	}
	/**
  * @description: 去除字符串两端的空白字符（或者只有左边、右边、全部）
  * @param {*} str 字符串
  * @param {*} type 去除方向
  * @return {*}
  */
	trimSting(str, type = 'both') {
		switch (type) {
		case 'both':
			return str.replace(/(^\s*)|(\s*$)/g, '')
		case 'left':
			return str.replace(/(^\s*)/g, '')
		case 'right':
			return str.replace(/(\s*$)/g, '')
		case 'all':
			return str.replace(/\s+/g, '')
		}
	}
	/**
  * @description: 函数节流
  * @param {*} func 函数
  * @param {*} wait 延迟执行毫秒数
  * @param {*} type 1 表时间戳版，2 表定时器版
  * @return {*}
  */
	throttle(func, wait, type) {
		let timeout
		let previous = 0
		return function() {
			const context = this
			const args = arguments
			if (type === 1) {
				const now = Date.now()
				if (now - previous > wait) {
					func.apply(context, args)
					previous = now
				}
			} else if (type === 2) {
				if (!timeout) {
					timeout = setTimeout(() => {
						timeout = null
						func.apply(context, args)
					}, wait)
				}
			}
		}
	}
}
const global = new Global()
export {
	global
}
